import React, { Component } from "react";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";

class ExchangeRatesContainer extends Component {
  state = {
    gbp: [],
    pln: [],
    usd: [],
  };

  UNSAFE_componentWillMount = () => {
    window.firebase
      .firestore()
      .collection("exchangeRatesGBP")
      .orderBy("timestamp", "desc")
      .get()
      .then((querySnapshot) => {
        let gbp = [];
        // let perYearPerMonth = {};
        querySnapshot.forEach((doc) => {
          let er = doc.data();
          er["id"] = doc.id;
          if (er.id !== "0000-00-00") {
            gbp.push(er);
          }
        });
        this.setState({ gbp: gbp });
      });
    window.firebase
      .firestore()
      .collection("exchangeRatesPLN")
      .orderBy("timestamp", "desc")
      .get()
      .then((querySnapshot) => {
        let pln = [];
        // let perYearPerMonth = {};
        querySnapshot.forEach((doc) => {
          let er = doc.data();
          er["id"] = doc.id;
          if (er.id !== "0000-00-00") {
            pln.push(er);
          }
        });
        this.setState({ pln: pln });
      });
    window.firebase
      .firestore()
      .collection("exchangeRatesUSD")
      .orderBy("timestamp", "desc")
      .get()
      .then((querySnapshot) => {
        let usd = [];
        // let perYearPerMonth = {};
        querySnapshot.forEach((doc) => {
          let er = doc.data();
          er["id"] = doc.id;
          if (er.id !== "0000-00-00") {
            usd.push(er);
          }
        });
        this.setState({ usd: usd });
      });
  };

  render() {
    return (
      <div
        style={{
          width: "100%",
          marginTop: 10,
          display: "flex",
          justifyContent: "space-evenly",
        }}
      >
        <Paper>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Date</TableCell>
                <TableCell>Rate (EUR-GBP)</TableCell>
                <TableCell>Timestamp</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {this.state.gbp.map((er) => (
                <TableRow key={er.id}>
                  <TableCell>{er.id}</TableCell>
                  <TableCell>{er.exchangeRate}</TableCell>
                  <TableCell>{er.timestamp}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Paper>
        <Paper>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Date</TableCell>
                <TableCell>Rate (EUR-PLN)</TableCell>
                <TableCell>Timestamp</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {this.state.pln.map((er) => (
                <TableRow key={er.id}>
                  <TableCell>{er.id}</TableCell>
                  <TableCell>{er.exchangeRate}</TableCell>
                  <TableCell>{er.timestamp}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Paper>
        <Paper style={{ height: "0%" }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Date</TableCell>
                <TableCell>Rate (EUR-USD)</TableCell>
                <TableCell>Timestamp</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {this.state.usd.map((er) => (
                <TableRow key={er.id}>
                  <TableCell>{er.id}</TableCell>
                  <TableCell>{er.exchangeRate}</TableCell>
                  <TableCell>{er.timestamp}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Paper>
      </div>
    );
  }
}

export default ExchangeRatesContainer;
